import type { TokenPayload } from "@packsize/identity-api-sdk";
import { jwtDecode } from "jwt-decode";

const tokenSuffix = "token";
let tokenPrefix = "unmanaged_";

/**
 * @deprecated This is only meant for backwards compatibility with the old authentication flow. Please use the managed useToken hook instead.
 * If you have questions about this please reach out to architecture.
 */
export const getUnmanagedTokenKey = (): string => {
	return `${tokenPrefix}${tokenSuffix}`;
};

/**
 * @deprecated This is only meant for backwards compatibility with the old authentication flow. Please use the managed useToken hook instead.
 * If you have questions about this please reach out to architecture.
 */
export const setUnmanagedTokenPrefix = (prefix: string) => {
	tokenPrefix = prefix;
};

/**
 * @deprecated This is only meant for backwards compatibility with the old authentication flow. Please use the managed useToken hook instead.
 * If you have questions about this please reach out to architecture.
 */
export const getUnmanagedToken = (): string | undefined => {
	const token = window.localStorage.getItem(getUnmanagedTokenKey());

	if (token === null) {
		return undefined;
	}

	return token;
};

/**
 * @deprecated This is only meant for backwards compatibility with the old authentication flow. Please use the managed useToken hook instead.
 * If you have questions about this please reach out to architecture.
 */
export const getUnmanagedBearerToken = (): string | undefined => {
	const token = getUnmanagedToken();

	if (token === undefined) {
		return undefined;
	}

	return `Bearer ${token}`;
};

export const decodeSsoToken = (encodedToken: string): string | null => {
	try {
		return atob(encodedToken);
	} catch (err) {
		console.error("Error decoding SSO token", err);
		return null;
	}
};

export const decodeJwtToken = (token: string | null): TokenPayload | null => {
	if (token === null) {
		return null;
	}

	try {
		return jwtDecode<TokenPayload>(token);
	} catch {
		return null;
	}
};
